import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>Page Not Found</h1>
      <p className="lead">Page you looking for does not exists</p>
    </div>
  );
};

export default NotFound;
